import script from "./IncidenceIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./IncidenceIcon.vue?vue&type=script&setup=true&lang=js"

import "./IncidenceIcon.vue?vue&type=style&index=0&id=02525140&scoped=true&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02525140"]])

export default __exports__